import React, { useCallback } from 'react';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { selectModalData } from '../../../redux/selectors/modal';
import { closeModal } from '../../../redux/slices/modal';
import { IncidentCreateModal } from '../../../components/Incidents/IncidentModals';
import KubitModal from '../../../components/KubitModal';
import { IIncident } from '../interfaces';

const UpdateIncidentModal = () => {
  const dispatch = useAppDispatch();
  const currentIncident = useAppSelector(selectModalData) as IIncident;
  const { start, end } = currentIncident;

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const incidentSelectedStartDate = moment(start).toDate();
  const incidentSelectedEndDate = moment(end).toDate();

  return (
    <KubitModal open={true} onClose={handleClose} maxWidth={550} noBodyWrapper>
      <IncidentCreateModal
        selectedStartDate={incidentSelectedStartDate}
        selectedEndDate={incidentSelectedEndDate}
        currentIncident={currentIncident}
        onClose={handleClose}
      />
    </KubitModal>
  );
};

export default UpdateIncidentModal;
